import { gql } from '@apollo/client';

const ROLE_FIELDS = `
  _id
  code
  label
  active
`;

export const GET_ROLES = gql`
  query getRoles {
    getRoles {
      ${ROLE_FIELDS}
    }
  }
`;

export const CREATE_ROLE = gql`
  mutation createRole($input: CreateRoleInput!) {
    createRole(input: $input) {
      ${ROLE_FIELDS}
    }
  }
`;

export const UPDATE_ROLE = gql`
  mutation updateRole($input: UpdateRoleInput!) {
    updateRole(input: $input) {
      ${ROLE_FIELDS}
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation deleteRole($code: String!) {
    deleteRole(code: $code)
  }
`;
